import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  private http = inject(HttpClient);

  public getAllByBusinessUnit(businessUnitId: number): Observable<Dtos.Area[]> {
    return this.http.get<Dtos.Area[]>(`${environment.apiUrl}/area/getByBusinessUnit/${businessUnitId}`);
  }

  public getAreaById(id: number): Observable<Dtos.Area> {
    return this.http.get<Dtos.Area>(`${environment.apiUrl}/area/${id}`);
  }

  public createArea(area: Dtos.Area): Observable<Dtos.Area> {
    return this.http.post<Dtos.Area>(`${environment.apiUrl}/area`, area);
  }

  public updateArea(area: Dtos.Area): Observable<Dtos.Area> {
    return this.http.put<Dtos.Area>(`${environment.apiUrl}/area`, area);
  }

  public deleteArea(id: number): Observable<Dtos.Area> {
    return this.http.put<Dtos.Area>(`${environment.apiUrl}/area/delete/${id}`, null);
  }

  public activateArea(id: number): Observable<Dtos.Area> {
    return this.http.put<Dtos.Area>(`${environment.apiUrl}/area/${id}/activate`, null);
  }
}
